<script lang="ts" setup>
import { type TaskItemAreaDto } from '@/api/generator';
import SingleSetupParameter from '@/views/tasks/components/SingleSetupParameter.vue';

interface SingleSetupParametersPropsProps {
  name: string;
  targetArea: TaskItemAreaDto;
  singleSetupParametersSelected: boolean;
}

defineProps<SingleSetupParametersPropsProps>();
</script>

<template>
  <div
    v-if="targetArea.medicalSystemSetup?.singleSetupParameters?.length"
    class="single-setup-parameters"
  >
    <div class="parameter-grid">
      <template
        v-for="parameter in targetArea.medicalSystemSetup.singleSetupParameters"
        :key="parameter.id"
      >
        <SingleSetupParameter
          :name="`${name}.medicalSystemSetup.singleSetupParameters[${targetArea?.medicalSystemSetup?.singleSetupParameters?.indexOf(
            parameter,
          )}]`"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.parameter-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px 24px;
  width: 100%;

  .single-setup-parameter {
    width: 100%;
  }
}
</style>
